<template>
  <div id="app">
    <header-component></header-component>
    <router-view></router-view>
    <footer-component></footer-component>
  </div>
</template>

<script>
require("./assets/img/favicon.ico");
require("./assets/img/mt-logo-2015.png");

export default {
  name: "app",
  mounted() {},
};
</script>

<style lang="scss">
@import "assets/scss/main";
</style>



// WEBPACK FOOTER //
// App.vue?557a0c71